import React from 'react';
import { useTranslation } from 'react-i18next';
import formatWithThousandSeparator from 'utils/thousand_separator';
import styles from './SpecialUserCard.module.scss';

const SpecialUserCard = ({
    name,
    logo,
    totalCount,
    usersCount,
    singleValue,
    singleValueLabel,
}) => {
    const { t } = useTranslation();
    const percentage = totalCount > 0 ? ((usersCount / totalCount) * 100).toFixed(1) : 0;
    const progressWidth = `${percentage}%`;
    const valueLabel = singleValueLabel || t('dash.card_count_label');

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <img src={logo} alt={name} className={styles.logo} title={name} />
                <div>
                    <h3 className={styles.title} title={name}>
                        {name}
                    </h3>
                </div>
            </div>

            {singleValue !== undefined ? (
                <div className={styles.singleValueContainer}>
                    <div className={styles.singleValue}>
                        {formatWithThousandSeparator(singleValue)}
                    </div>
                    <div className={styles.singleValueLabel}>{valueLabel}</div>
                </div>
            ) : (
                <>
                    <div className={styles.progressContainer}>
                        <div className={styles.progressHeader}>
                            <span className={styles.progressLabel}>
                                {t('dash.registered_users')}
                            </span>
                            <span className={styles.progressLabel}>{percentage}%</span>
                        </div>
                        <div className={styles.progressBar}>
                            <div
                                className={styles.progressFill}
                                style={{ width: progressWidth }}
                            />
                        </div>
                    </div>

                    <div className={styles.statsContainer}>
                        <div className={styles.statItem}>
                            <div className={styles.statValue}>
                                {formatWithThousandSeparator(usersCount)}
                            </div>
                            <div className={styles.statLabel}>{t('dash.card_users')}</div>
                        </div>
                        <div className={styles.statItem}>
                            <div className={styles.statValue}>
                                {formatWithThousandSeparator(totalCount)}
                            </div>
                            <div className={styles.statLabel}>{t('dash.card_total')}</div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default SpecialUserCard;
